import { Button } from '@tempo-io/sui-button';
import { cn } from '@tempo-io/sui-class-utils';
import type { Item } from '@/common/api/types/items';
import type { ItemTypeMap } from '@/common/api/types/itemType';
import { ItemTypeIcon } from '@/common/components/ui/item-type/itemTypeIcon';
import { useItemPanelNavigation } from '@/features/item-panel/hooks/useItemPanelParams';

export const ItemValueButton = ({
  item,
  itemTypesById,
}: {
  item: Pick<Item, 'id' | 'name' | 'itemTypeId'>;
  itemTypesById: ItemTypeMap;
}) => {
  const { id: itemId, name, itemTypeId } = item;
  const { openItemPanel } = useItemPanelNavigation();

  const handleClick = () => {
    if (itemId) {
      openItemPanel({ itemId });
    }
  };

  const itemType = itemTypesById[itemTypeId];

  return (
    <Button
      type="button"
      variant="outline"
      className={cn('w-30 flex basis-[content] gap-1 truncate')}
      onClick={handleClick}
    >
      {!!itemType && <ItemTypeIcon itemType={itemType} />}
      {name}
    </Button>
  );
};
